module.exports = __webpack_public_path__ + "static/screen-android-mobile-8e0422b29c35d80dbd1a9d802094577c.png";